import React from 'react';
import PropTypes from 'prop-types';
import styles from './ScheduleStats.module.scss';
import { ReactComponent as UserIcon } from './icons/User.svg';
import { ReactComponent as UsersIcon } from './icons/Users.svg';
import { ReactComponent as UserPlusIcon } from './icons/UserPlus.svg';
import { ReactComponent as ClinicIcon } from './icons/Clinic.svg';
import { ReactComponent as CalendarIcon } from './icons/Calendar.svg';

const ScheduleStats = ({ stats, isLoading }) => {
  const statsConfig = [
    { title: 'Total Students', value: stats?.totalStudents ?? '0', icon: UsersIcon, colorClass: styles.color1 },
    { title: 'Total Clinical Sites', value: stats?.totalClinicalSites ?? '0', icon: ClinicIcon, colorClass: styles.color2 },
    { title: 'Total Capacity', value: stats?.totalCapacity ?? '0', icon: UsersIcon, colorClass: styles.color3 },
    { title: 'Allocated', value: stats?.allocatedStudents ?? '0', icon: UserPlusIcon, colorClass: styles.color4 },
    { title: 'Unallocated', value: stats?.unallocatedStudents ?? '0', icon: UserIcon, colorClass: styles.color5 },
    { title: 'Schedule Progress', value: `${stats?.scheduleProgress ?? '0'}%`, icon: CalendarIcon, colorClass: styles.color6 },
  ];

  return (
    <div className={styles.statsContainer}>
      {statsConfig.map((stat, index) => {
        const IconComponent = stat.icon;
        return (
          <div key={index} className={`${styles.statCard} ${stat.colorClass}`}>
            <div className={styles.statHeader}>
              <span className={styles.title}>{stat.title}</span>
            </div>
            <div className={styles.statFooter}>
              <span className={styles.value}>
                {isLoading ? '...' : stat.value}
              </span>
              <IconComponent className={styles.icon} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

ScheduleStats.propTypes = {
  stats: PropTypes.shape({
    totalStudents: PropTypes.number,
    totalClinicalSites: PropTypes.number,
    totalCapacity: PropTypes.number,
    allocatedStudents: PropTypes.number,
    unallocatedStudents: PropTypes.number,
    scheduleProgress: PropTypes.number
  }),
  isLoading: PropTypes.bool
};

export default ScheduleStats;
